module.exports = __webpack_public_path__ + "img/sw-ps-lg.5918ee23.webp";